module.exports = __webpack_public_path__ + "media/icons/logo-small-06e85ebb.svg";